import { Animations } from 'src/app/core/angular-animations/angular-animations';
import { Component, Input, OnInit } from '@angular/core';
import {
  LogActionEnum,
  LogActionLabelDescription,
  LogActionLabels,
} from 'src/app/shared/enums/log-action.enum';
import { IGenericLogFieldChange } from 'src/app/shared/models/generic-log.model';
import { TIME_FORMAT } from 'src/app/core/ccomx-date-formats';

@Component({
  selector: 'app-generic-log-template',
  templateUrl: './generic-log-template.component.html',
  styleUrls: ['./generic-log-template.component.scss'],
  animations: [Animations.rotatedState],
  standalone: false,
})
export class GenericLogTemplateComponent implements OnInit {
  @Input() columnName: string;
  @Input() element: any;
  @Input() statusColor: string;
  @Input() tableColor: string;

  logActionEnum = LogActionEnum;
  logActionLabels: any = LogActionLabels;
  logActionLabelDescription: any = LogActionLabelDescription;
  timeFormat = TIME_FORMAT;
  fieldChangesWithTranslations: Array<IGenericLogFieldChange & { translationKey: string }> = [];

  constructor() {}

  ngOnInit(): void {
    this.fieldChangesWithTranslations = (this.element?.fieldsChanged || []).map(
      (fieldChange: IGenericLogFieldChange) => {
        let translationKey = 'changedTo';
        if (this.element.action === LogActionEnum.Created) {
          translationKey = 'hasBeenAssignedAValueOf';
        }
        if (this.element.action === LogActionEnum.Edited) {
          translationKey = 'hasBeenUpdated';
        }
        if (
          fieldChange.fieldName === 'attachmentsAdded' ||
          fieldChange.fieldName === 'attachmentsRemoved' ||
          fieldChange.fieldName === 'positionsWithAccessAdded' ||
          fieldChange.fieldName === 'positionsWithAccessRemoved' ||
          fieldChange.fieldName === 'positionGroupsWithAccessAdded' ||
          fieldChange.fieldName === 'positionGroupsWithAccessRemoved'
        ) {
          translationKey = '';
        }
        if (
          (fieldChange.fieldName === 'expirationDate' && fieldChange.value === null) ||
          (fieldChange.fieldName === 'revisionDates' && fieldChange.value === '')
        ) {
          translationKey = 'hasBeenRemoved';
        }

        if (fieldChange.fieldName === 'UserDefinedCertificateNumber') {
          fieldChange = { ...fieldChange, fieldName: 'customCertificateNumber' };
        }
        return {
          ...fieldChange,
          translationKey,
        };
      }
    );
  }
}
